module.exports = {
  componentName: 'Recaptcha',

  props: {
    sitekey: {
      type: String,
      required: true
    },

    theme: {
      type: String,
      default: 'light'
    },

    size: {
      type: String,
      default: 'normal'
    },

    tabindex: {
      type: Number,
      default: 0
    }
  },

  mounted () {
    this.$eventsBus.$on('RecaptchaReadyEvent', () => {
      this.render();
    });

    this.$eventsBus.$on('recaptcha-reset', () => {
      this.reset();
    });

    // If the recaptcha component is mounted after the recaptcha ready
    // events have triggered, render the recaptcha if available.
    if (typeof grecaptcha !== 'undefined') {
      this.render();
    }
  },

  methods: {
    render () {
      if (typeof this.$el.dataset.rendered !== 'undefined') {
        return;
      }

      this.widgetId = grecaptcha.render(this.$el, {
        ...this.$props,
        callback: this.handleResponse,
        'expired-callback': this.fireOnExpired
      });

      this.$el.dataset.rendered = true;
    },

    reset () {
      grecaptcha.reset(this.widgetId);
    },

    getResponse () {
      return grecaptcha.getResponse(this.widgetId);
    },

    handleResponse (response) {
      this.$emit('recaptcha-response', response);
    },

    fireOnExpired () {
      this.reset();
      this.$emit('recaptcha-expired');
    }
  },
  render (h) {
    return h('div');
  }
};
